import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useDict } from "lib/dict";
import { PURCHASE_REQUEST_RESOURCES, RESOURCES } from "components/role/RoleForm";
import type { PermissionDenial } from "lib/permission/permissionDenied";
import { permissionDeniedMessage } from "lib/permission/permissionDeniedMessage";

type Props = {
  denial: PermissionDenial | null;
  onClose: () => void;
};

const ALL_RESOURCES = [...RESOURCES, ...PURCHASE_REQUEST_RESOURCES];

// API がロールの権限不足で断ったことを、要る権限の名前とあわせて知らせる。
// 閉じている間は dict を参照しない（/404 の prerender など dict の無いページで落とさない）。
const PermissionDeniedNotice = (props: Props) =>
  props.denial === null ? null : <OpenNotice denial={props.denial} onClose={props.onClose} />;

const OpenNotice = ({ denial, onClose }: { denial: PermissionDenial; onClose: () => void }) => {
  const { d } = useDict();
  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={(_, reason) => {
        // 画面のほかの場所を押しただけでは閉じない。読み終える前に消えないように
        if (reason !== "clickaway") onClose();
      }}
    >
      <Alert severity="error" onClose={onClose}>
        {permissionDeniedMessage(denial, ALL_RESOURCES, d)}
      </Alert>
    </Snackbar>
  );
};

export default PermissionDeniedNotice;
